import { Component, Input, Output, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {
  FeatureMap,
  MarkerComponent,
  SizeUnit, SIZE_UNIT,
  VerticalAlignment, VERTICAL_ALIGNMENT,
  HorizontalAlignment, HORIZONTAL_ALIGNMENT
} from '@realpage-da/ng-map';

@Component({
  selector: 'property-marker',
  template: `
  <div (click)="onMouseEvent.next('click')"
  class="property-badge-xs">
</div>`,
  styleUrls: ['./property-marker.component.scss']
})
export class PropertyMarkerComponent extends MarkerComponent implements OnInit {
  defaultColor = '#AFB3B6';
  map: FeatureMap;

  sizeUnit = SIZE_UNIT.EM as SizeUnit;
  horizontalAlignment = HORIZONTAL_ALIGNMENT.CENTER as HorizontalAlignment;
  verticalAlignment = VERTICAL_ALIGNMENT.ABOVE as VerticalAlignment;

  width = 0;
  height = 0;
  baseZoom: number = 8;
  scaleFactor: number = 1.5;

  ngOnInit() {
    /*this.onClick
      .filter(f => !!this.map)
      .subscribe(() => this.map.addTooltip(this.marker));*/
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/map/property-marker.component.ts